import { Avatar, Button, Flex, Space, Tag, Typography } from "antd";
import {
  ScheduleOutlined,
  CloseOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import EllipsisText from "components/EllipsisText";
import { getIssueStatusLabel } from "helpers/options/issue_statuses";
import formatPhone from "helpers/phone_formatter";
import getIssueType from "helpers/issue_types";
import { useCalendarIssues } from "components/CalendarIssues/context";

const IssueTitle = ({ close, issues }) => {
  const navigate = useNavigate();
  const { setCalendarIssueId } = useCalendarIssues();
  const {
    id,
    worker,
    status,
    client_street,
    client_building_number,
    client_apartment_number,
    client_city,
    client_post_code,
    client_phone,
    issue_type,
  } = issues[0];
  const type = getIssueType(issue_type);

  return (
    <div className="calendar-viewer">
      <div className="calendar-viewer__header">
        <Button onClick={close} type="primary" ghost icon={<CloseOutlined />} />
      </div>
      {worker?.id && (
        <>
          <Space style={{ marginBottom: 10 }}>
            <Avatar
              style={{
                backgroundColor: worker?.color,
              }}
            >
              {worker.initials}
            </Avatar>
            <Typography.Text delete={worker?.is_deleted}>
              <EllipsisText text={worker.full_name} limit={30} />
            </Typography.Text>
          </Space>
          <br />
        </>
      )}
      <Flex gap={5} style={{ marginBottom: 5 }}>
        {getIssueStatusLabel(status)}
        <Tag color={type.color}>{type.label}</Tag>
      </Flex>
      <Typography.Text strong>
        {client_street} {client_building_number}/{client_apartment_number}
      </Typography.Text>
      <br />
      <Typography.Text strong>
        {client_city} {client_post_code}
      </Typography.Text>
      <br />
      <Typography.Text strong>{formatPhone(client_phone)}</Typography.Text>
      <br />
      <Flex justify="flex-end" gap={10} style={{ marginTop: 10 }}>
        <Button
          onClick={() => {
            setCalendarIssueId(id);
            close();
          }}
          type="primary"
          ghost
          icon={<ScheduleOutlined />}
        >
          Przenieś
        </Button>
        <Button
          onClick={() => {
            navigate(`/issues/${id}`);
            window.scrollTo(0, 0);
          }}
          type="primary"
          ghost
          icon={<EditOutlined />}
        >
          Edytuj
        </Button>
      </Flex>
    </div>
  );
};

export default IssueTitle;
